import { List, ListItem } from "@mui/material";
import { VegKamera } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import webcamIconSource from "../../assets/cctv.svg"

export default function Vegkameraer (props: IRoutePartProps) {

    return (      
        <>
            {props.roadFeatures && props.roadFeatures.vegkameraer && props.roadFeatures.vegkameraer.length > 0 &&
            <List>
                {props.roadFeatures.vegkameraer.map( (vegkamera: VegKamera, index: number) => (
                    <ListItem 
                        key= {vegkamera.cameraId + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(vegkamera, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(vegkamera)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            <img src={webcamIconSource} height="24" style={{paddingRight:"5px"}} alt="Vegkamera icon" title="vegkameraIcon"/>
                            {vegkamera.description}
                    </ListItem>
                ))}
            </List>        
            }
        </>  
    )
}